package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.promocodes.PromoCodesAdminScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_admin_promo_codes
import com.nonopn.skywatcher.design.appbar.AppBarState
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

private const val PromoCodesAdminPath = "/admin/promotion-codes"

@Serializable
object RoutePromotionCodesAdmin : RouteParameterTo

/** Administrator mode: list of the promotion codes (menu entry "Promo codes"). */
object RouterPromotionCodesAdmin : RouterNoParameters<RoutePromotionCodesAdmin>(RoutePromotionCodesAdmin::class) {
    override fun routeFrom(parameters: RoutePromotionCodesAdmin) = PromoCodesAdminPath

    @Composable
    override fun Show(parameters: RoutePromotionCodesAdmin) {
        RoutePromotionCodesAdminImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RoutePromotionCodesAdmin,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    // The form of a code belongs to this entry of the menu
    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        routeParameterTo is RoutePromotionCodesAdmin || routeParameterTo is RoutePromotionCodeEditAdmin

    override fun isMatching(route: String) = route.substringBefore('?').trimEnd('/') == PromoCodesAdminPath

    override fun navigateFrom(path: String) = RoutePromotionCodesAdmin
}

class RoutePromotionCodesAdminImpl : Route<RoutePromotionCodesAdmin>(
    route = PromoCodesAdminPath,
    params = RoutePromotionCodesAdmin,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        // The administrator role is given by the server (admin API of the session): nothing for other accounts
        if (state.apiProvider?.apiAdmin == null) {
            LaunchedEffect(Unit) { appModel.leaveAdminRoute() }
            return
        }

        LaunchedEffect(Unit) {
            appModel.ensureAdminMode()
            appModel.markCurrentRoute(RoutePromotionCodesAdmin)
            appModel.setAppBarState(AppBarState.Localized(title = Res.string.menu_admin_promo_codes, emptyList()))
        }

        PromoCodesAdminScreen(
            modifier = Modifier.fillMaxSize(),
            onEdit = { uuid ->
                appModel.show(RouterPromotionCodeEditAdmin.navigateTo(RoutePromotionCodeEditAdmin(uuid)))
            },
            onCreate = {
                appModel.show(
                    RouterPromotionCodeEditAdmin.navigateTo(RoutePromotionCodeEditAdmin(RoutePromotionCodeEditAdmin.NEW))
                )
            },
        )
    }
}
